import React, { useMemo,useRef, useState, useEffect } from "react";
import "./style.css";
import { updateProfessionalExperience, fetchSearch } from "../../../Redux/Actions/ProfileSteps";
import { useDispatch, useSelector } from "react-redux";
import { RESET_SEARCH } from "../../../Redux/Actions/types";

const ProfessionalExperience = ({ setCurrentStep }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const [tempData, setTempData] = useState({});
  const [isChanged, setIsChanged] = useState({});
  
  const profileData = useSelector(s => s.ProfileSteps.profileData);
  const kids = useSelector((state) => state.dashboard.kids);
  
  const [workexDomainSearch, setWorkexDomainSearch] = useState("");
  const [workexDomain, setWorkexDomain] = useState("");
  const workexDomainSearchResults = useSelector(s => s.ProfileSteps.searchByField.lastWorkexDomain);
  
  const [workexIndustrySearch, setWorkexIndustrySearch] = useState("");
  const [workexIndustry, setWorkexIndustry] = useState("");
  const workexIndustrySearchResults = useSelector(s => s.ProfileSteps.searchByField.lastWorkexIndustry);
const workexDomainRef = useRef(null);
const workexIndustryRef = useRef(null);

// Add useEffect to handle outside clicks
// useEffect(() => {
//   const handleClickOutside = (event) => {
//     if ((workexDomainRef.current && !workexDomainRef.current.contains(event.target))|| (workexIndustryRef.current && !workexIndustryRef.current.contains(event.target))) {
//       dispatch({ type: RESET_SEARCH });
//     }
//   };

//   document.addEventListener('mousedown', handleClickOutside);
//   return () => {
//     document.removeEventListener('mousedown', handleClickOutside);
//   };
// }, [dispatch]);

useEffect(() => {
  const handleClickOutside = (event) => {
    // Close domain dropdown independently
    if (workexDomainRef.current && 
        !workexDomainRef.current.contains(event.target) && 
        workexDomainSearchResults?.length > 0) {
      setWorkexDomainSearch('');
      dispatch({ type: RESET_SEARCH }); // Add this
    }
    
    // Close industry dropdown independently  
    if (workexIndustryRef.current && 
        !workexIndustryRef.current.contains(event.target) && 
        workexIndustrySearchResults?.length > 0) {
      setWorkexIndustrySearch('');
      dispatch({ type: RESET_SEARCH }); // Add this
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [dispatch, workexDomainSearchResults, workexIndustrySearchResults]);

  // Debounced search for work domain
  const [debouncedWorkexDomainSearch, setDebouncedWorkexDomainSearch] = useState('');
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedWorkexDomainSearch(workexDomainSearch);
    }, 500);
    return () => clearTimeout(handler);
  }, [workexDomainSearch]);

  useEffect(() => {
    const fetchData = async () => {
      if (debouncedWorkexDomainSearch.length >= 3) {
        try {
          await dispatch(fetchSearch({ 
            search_type: "lastWorkexDomain", 
            search_char: debouncedWorkexDomainSearch, 
            context: "lastWorkexDomain" 
          }));
        } catch (error) {
          console.error("Failed to fetch domains:", error);
        }
      } else {
        dispatch({ type: RESET_SEARCH });
      }
    };
    fetchData();
  }, [debouncedWorkexDomainSearch, dispatch]);

  // Debounced search for work industry
  const [debouncedWorkexIndustrySearch, setDebouncedWorkexIndustrySearch] = useState('');
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedWorkexIndustrySearch(workexIndustrySearch);
    }, 500);
    return () => clearTimeout(handler);
  }, [workexIndustrySearch]);

  useEffect(() => {
    const fetchData = async () => {
      if (debouncedWorkexIndustrySearch.length >= 3) {
        try {
          await dispatch(fetchSearch({ 
            search_type: "lastWorkexIndustry", 
            search_char: debouncedWorkexIndustrySearch, 
            context: "lastWorkexIndustry" 
          }));
        } catch (error) {
          console.error("Failed to fetch industries:", error);
        }
      } else {
        dispatch({ type: RESET_SEARCH });
      }
    };
    fetchData();
  }, [debouncedWorkexIndustrySearch, dispatch]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setIsChanged((prev) => ({ ...prev, [name]: true }));
  };

  const handleTempInputChange = (e) => {
    const { name, value } = e.target;
    
    // Handle edge case: If user updates thousands without having changed lakhs
    if (name === "last_drawn_ctc_thousands" && !tempData.hasOwnProperty("last_drawn_ctc_lakhs")) {
      const lakhsValue = Math.floor(profileData?.last_drawn_ctc || 0);
      setTempData((prev) => ({ ...prev, last_drawn_ctc_lakhs: lakhsValue }));
    }
    // Handle edge case: If user updates total work exp months without having changed years
    else if (name === "total_work_exp_months" && !tempData.hasOwnProperty("total_work_exp_years")) {
      const yearsValue = Math.floor((profileData?.work_experience_duration || 0) / 12);
      setTempData((prev) => ({ ...prev, total_work_exp_years: yearsValue }));
    }
    // Handle edge case: If user updates last work exp months without having changed years
    else if (name === "last_work_exp_months" && !tempData.hasOwnProperty("last_work_exp_years")) {
      const yearsValue = Math.floor((profileData?.last_workex_duration || 0) / 12);
      setTempData((prev) => ({ ...prev, last_work_exp_years: yearsValue }));
    }
    // Handle edge case: If user updates total work exp years without having changed months
    else if (name === "total_work_exp_years" && !tempData.hasOwnProperty("total_work_exp_months")) {
      const monthsValue = (profileData?.work_experience_duration || 0) % 12;
      setTempData((prev) => ({ ...prev, total_work_exp_months: monthsValue }));
    }
    // Handle edge case: If user updates last work exp years without having changed months
    else if (name === "last_work_exp_years" && !tempData.hasOwnProperty("last_work_exp_months")) {
      const monthsValue = (profileData?.last_workex_duration || 0) % 12;
      setTempData((prev) => ({ ...prev, last_work_exp_months: monthsValue }));
    }
    // Handle edge case: If user updates lakhs without having changed thousands
    else if (name === "last_drawn_ctc_lakhs" && !tempData.hasOwnProperty("last_drawn_ctc_thousands")) {
      const thousandsValue = Math.round(((profileData?.last_drawn_ctc || 0) % 1) * 100);
      setTempData((prev) => ({ ...prev, last_drawn_ctc_thousands: thousandsValue }));
    }
    
    setTempData((prev) => ({ ...prev, [name]: value }));
    
    // If lakhs = 100 (1 crore), reset thousands to empty
    if (name === "last_drawn_ctc_lakhs" && value === "100") {
      setTempData((prev) => ({ ...prev, last_drawn_ctc_thousands: "" }));
    }
    
    setIsChanged((prev) => ({ ...prev, [name]: true }));
  };

  const monthOptions = useMemo(
    () => Array.from({ length: 12 }, (_, i) => i + 1),
    []
  );
  
  const workMonthOptions = useMemo(
    () => Array.from({ length: 12 }, (_, i) => i),
    []
  );
  
  const yearOptions = useMemo(
    () => Array.from({ length: 51 }, (_, i) => i),
    []
  );
  
  const ctcLakhsOptions = useMemo(
    () => Array.from({ length: 100 }, (_, i) => i + 1),
    []
  );
  
  const ctcThousandsOptions = useMemo(
    () => Array.from({ length: 100 }, (_, i) => i),
    []
  );

  const handleSaveAndNext = async () => {
    try {
      const hasData = (formData && Object.keys(formData).length > 0) || (tempData && Object.keys(tempData).length > 0);
      
      if (hasData) {
        const updatedFormData = {
          ...formData,
          kid_id: kids?.[0]?.id,
        };

        // Handle total work experience conversion (years + months → months)
        if (tempData.hasOwnProperty("total_work_exp_years") || tempData.hasOwnProperty("total_work_exp_months")) {
          const years = tempData.hasOwnProperty("total_work_exp_years") 
            ? Number(tempData.total_work_exp_years || 0)
            : Math.floor((profileData?.work_experience_duration || 0) / 12);
          
          const months = tempData.hasOwnProperty("total_work_exp_months")
            ? Number(tempData.total_work_exp_months || 0)
            : (profileData?.work_experience_duration || 0) % 12;
          
          updatedFormData.work_experience_duration = (years * 12) + months;
        }

        // Handle last work experience conversion (years + months → months)
        if (tempData.hasOwnProperty("last_work_exp_years") || tempData.hasOwnProperty("last_work_exp_months")) {
          const years = tempData.hasOwnProperty("last_work_exp_years")
            ? Number(tempData.last_work_exp_years || 0)
            : Math.floor((profileData?.last_workex_duration || 0) / 12);
          
          const months = tempData.hasOwnProperty("last_work_exp_months")
            ? Number(tempData.last_work_exp_months || 0)
            : (profileData?.last_workex_duration || 0) % 12;
          
          updatedFormData.last_workex_duration = (years * 12) + months;
        }

        // Handle CTC conversion (lakhs.thousands → decimal)
        if (tempData.hasOwnProperty("last_drawn_ctc_lakhs") || tempData.hasOwnProperty("last_drawn_ctc_thousands")) {
          const lakhs = tempData.hasOwnProperty("last_drawn_ctc_lakhs")
            ? Number(tempData.last_drawn_ctc_lakhs || 0)
            : Math.floor(profileData?.last_drawn_ctc || 0);
          
          // If lakhs = 100, it's 1 crore, ignore thousands
          if (lakhs === 100) {
            updatedFormData.last_drawn_ctc = 100;
          } else {
            const thousands = tempData.hasOwnProperty("last_drawn_ctc_thousands")
              ? Number(tempData.last_drawn_ctc_thousands || 0)
              : Math.round(((profileData?.last_drawn_ctc || 0) % 1) * 100);
            
            // Format as decimal: 3.46 = 3 lakhs 46 thousands
            updatedFormData.last_drawn_ctc = Number(`${lakhs}.${thousands.toString().padStart(2, '0')}`);
          }
        }

        await dispatch(updateProfessionalExperience(updatedFormData));
      }

      setCurrentStep(7);
    } catch (err) {
      console.error("Error updating professional experience:", err);
    }
  };
const initialFetch = async(type, context) => {
  try {await dispatch({ type: RESET_SEARCH})
          await dispatch(
            fetchSearch({
              search_type: type,
              search_char: "prominentdef",
              context: context,
            })
          );
        } catch (err) {
          console.error(" search failed:", err);
        }
}
  return (
    <>
      <div className="container-fluid">
        <div className="col-md-8 offset-md-2 py-5">
          <div className="form-bg">
            <div className="form-group">
              <label>Internship Company Name</label>
              <input
                type="text"
                className="form-control"
                name="last_intern_company"
                value={isChanged?.last_intern_company ? formData?.last_intern_company : profileData?.last_intern_company || ""}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group">
              <label>Internship Department</label>
              <input
                type="text"
                className="form-control"
                name="last_intern_department"
                value={isChanged?.last_intern_department ? formData?.last_intern_department : profileData?.last_intern_department || ""}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group">
              <label>Internship Duration (in months)</label>
              <select
                className="form-control"
                name="last_intern_duration"
                value={isChanged?.last_intern_duration ? formData?.last_intern_duration : profileData?.last_intern_duration || ""}
                onChange={handleInputChange}
              >
                <option value="">Select months</option>
                {monthOptions.map((m) => (
                  <option key={m} value={m}>
                    {m} month{m > 1 ? "s" : ""}
                  </option>
                ))}
              </select>
            </div>
            </div>
<div className="divider-line"></div>
<div className="form-bg">
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Total Work Experience Duration</label>
                  <select
                    className="form-control"
                    name="total_work_exp_years"
                    value={
                      isChanged?.total_work_exp_years 
                        ? tempData?.total_work_exp_years 
                        : Math.floor((profileData?.work_experience_duration || 0) / 12)
                    }
                    onChange={handleTempInputChange}
                  >
                    <option value="">Select years</option>
                    {yearOptions.map((y) => (
                      <option key={y} value={y}>
                        {y} year{y === 1 ? "" : "s"}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group" style={{marginTop: "13px"}}>
                  <label></label>
                  <select
                    className="form-control"
                    name="total_work_exp_months"
                    value={
                      isChanged?.total_work_exp_months 
                        ? tempData?.total_work_exp_months 
                        : (profileData?.work_experience_duration || 0) % 12
                    }
                    onChange={handleTempInputChange}
                  >
                    <option value="">Select months</option>
                    {workMonthOptions.map((m) => (
                      <option key={m} value={m}>
                        {m} month{m === 1 ? "" : "s"}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="form-group placholder">
              <label htmlFor="current_workexDomain">Last Work Experience Domain</label>
              <div className="position-relative" ref={workexDomainRef}>
                <input
                  type="text"
                  name="home_workexDomain"
                  className="form-control bg-white mb-3"
                  placeholder="Type 3+ characters to search"
                  onFocus={() => initialFetch("lastWorkexDomain","lastWorkexDomain")}
                  value={isChanged?.home_workexDomain ? workexDomain : profileData?.last_workex_domain || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    setWorkexDomain(value);
                    setWorkexDomainSearch(value);
                    setIsChanged((prev) => ({ ...prev, home_workexDomain: true }));
                  }}
                />
                {workexDomainSearchResults && workexDomainSearchResults.length > 0 && (
                  <ul 
                    className="list-group position-absolute w-100" 
                    style={{ maxHeight: '200px', overflowY: 'auto', zIndex: 1000, top: '100%' }}
                  >
                    {workexDomainSearchResults.map((item, idx) => (
                      <li 
                        key={idx} 
                        className="list-group-item list-group-item-action" 
                        onClick={() => {
                          setFormData(prev => ({ 
                            ...prev, 
                            workex_domain: item.object_id,
                            last_workex_domain: item.object_name 
                          }));
                          setIsChanged((prev) => ({ ...prev, home_workexDomain: true }));
                          setWorkexDomain(item.object_name);
                          setWorkexDomainSearch('');
                          dispatch({ type: RESET_SEARCH });
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        {item.object_name}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>

            <div className="form-group placholder">
              <label htmlFor="current_workexIndustry">Last Work Experience Industry</label>
              <div className="position-relative" ref={workexIndustryRef}>
                <input
                  type="text"
                  name="home_workexIndustry"
                  className="form-control bg-white mb-3"
                  placeholder="Type 3+ characters to search"
                  onFocus={() => initialFetch("lastWorkexIndustry","lastWorkexIndustry")}
                  value={isChanged?.home_workexIndustry ? workexIndustry : profileData?.last_workex_industry || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    setWorkexIndustry(value);
                    setWorkexIndustrySearch(value);
                    setIsChanged((prev) => ({ ...prev, home_workexIndustry: true }));
                  }}
                />
                {workexIndustrySearchResults && workexIndustrySearchResults.length > 0 && (
                  <ul 
                    className="list-group position-absolute w-100" 
                    style={{ maxHeight: '200px', overflowY: 'auto', zIndex: 1000, top: '100%' }}
                  >
                    {workexIndustrySearchResults.map((item, idx) => (
                      <li 
                        key={idx} 
                        className="list-group-item list-group-item-action" 
                        onClick={() => {
                          setFormData(prev => ({ 
                            ...prev, 
                            workex_industry: item.object_id,
                            last_workex_industry: item.object_name 
                          }));
                          setWorkexIndustry(item.object_name);
                          setWorkexIndustrySearch('');
                    setIsChanged((prev) => ({ ...prev, home_workexIndustry: true }));
                          dispatch({ type: RESET_SEARCH });
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        {item.object_name}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>

            <div className="form-group">
              <label>Last Work Company Name</label>
              <input
                type="text"
                className="form-control"
                name="last_workex_company"
                value={isChanged?.last_workex_company ? formData?.last_workex_company : profileData?.last_workex_company || ""}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group">
              <label>Last Work Designation</label>
              <input
                type="text"
                className="form-control"
                name="last_workex_designation"
                value={isChanged?.last_workex_designation ? formData?.last_workex_designation : profileData?.last_workex_designation || ""}
                onChange={handleInputChange}
              />
            </div>

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Last Work Experience Duration</label>
                  <select
                    className="form-control"
                    name="last_work_exp_years"
                    value={
                      isChanged?.last_work_exp_years 
                        ? tempData?.last_work_exp_years 
                        : Math.floor((profileData?.last_workex_duration || 0) / 12)
                    }
                    onChange={handleTempInputChange}
                  >
                    <option value="">Select years</option>
                    {yearOptions.map((y) => (
                      <option key={y} value={y}>
                        {y} year{y === 1 ? "" : "s"}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group" style={{marginTop: "13px"}}>
                  <label></label>
                  <select
                    className="form-control"
                    name="last_work_exp_months"
                    value={
                      isChanged?.last_work_exp_months 
                        ? tempData?.last_work_exp_months 
                        : (profileData?.last_workex_duration || 0) % 12
                    }
                    onChange={handleTempInputChange}
                  >
                    <option value="">Select months</option>
                    {workMonthOptions.map((m) => (
                      <option key={m} value={m}>
                        {m} month{m === 1 ? "" : "s"}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Last Drawn CTC</label>
                  <select
                    className="form-control"
                    name="last_drawn_ctc_lakhs"
                    value={
                      isChanged?.last_drawn_ctc_lakhs 
                        ? tempData?.last_drawn_ctc_lakhs 
                        : Math.floor(profileData?.last_drawn_ctc || 0)
                    }
                    onChange={handleTempInputChange}
                  >
                    <option value="">Select Lakhs</option>
                    {ctcLakhsOptions.map((m) => (
                      <option key={m} value={m}>
                        {m === 100 ? "1 crore" : `${m} lakh${m > 1 ? "s" : ""}`}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group" style={{marginTop: "13px"}}>
                  <label> </label>
                  <select
                    className="form-control"
                    name="last_drawn_ctc_thousands"
                    value={
                      isChanged?.last_drawn_ctc_thousands
                        ? tempData?.last_drawn_ctc_thousands
                        : Math.round(((profileData?.last_drawn_ctc || 0) % 1) * 100)
                    }
                    onChange={handleTempInputChange}
                    disabled={tempData.last_drawn_ctc_lakhs === "100"}
                  >
                    <option value="">Select Thousands</option>
                    {ctcThousandsOptions.map((m) => (
                      <option key={m} value={m}>
                        {m} thousand{m === 1 ? "" : "s"}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="btn-footer">
        <div className="container-fluid d-flex justify-content-lg-end">
          <button 
            className='default-btn default-border bg-transparent back-btn me-3'
            onClick={() => setCurrentStep(5)}
          >
            <img src="./images/back-arrow.png" className='d-block d-md-none' alt="back" />
            <span className='d-none d-md-block'>Back</span>
          </button>
          <button
            className="default-btn default-border bg-transparent me-3"
            onClick={() => setCurrentStep(7)}
          >
            Skip
          </button>
          <button className="default-btn" onClick={handleSaveAndNext}>
            Save & Next
          </button>
        </div>
      </div>
    </>
  );
};

export default ProfessionalExperience;
